import React from 'react';
import styled from 'styled-components';
import Box from '../../../../../../components/box';
import { H1, H2, H3, H4, P } from '../../../../components';
import Container from '../../../../../../components/container';


const BlockStyled = styled(Box)`
  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const BlockItem1Styled = styled(Box)`
  > img {
    width: 100%;
  }

  @media (min-width: 769px) {
    flex: 2;
    background-image: url(${process.env.NEXT_PUBLIC_PUBLIC_URL}/img/cours/private/students.png);
    background-size: cover;
    background-position: top right;
    margin-right: 10px;

    > img {
      display: none;
    }
  }
`;

const BlockItem2Styled = styled(Box)`
  padding: 20px;

  @media (min-width: 769px) {
    flex: 3;
    padding: 50px;
  }
`;

function StudentCommunitySection({grey, title, ...rest}) {
  return (
    <Box backgroundGrey={grey} {...rest}>
      <Container>
        <H3 lineBlue mb={3}>{title}</H3>
      </Container>

      <BlockStyled flex>
        <BlockItem1Styled>
          <img src={`${process.env.NEXT_PUBLIC_PUBLIC_URL}/img/cours/private/students.png`} />
        </BlockItem1Styled>

        <BlockItem2Styled backgroundWhite>
          <Box style={{maxWidth: 650}} fontSize={24} lineHeight={1.5}>
            L’objectif de Clevermate est de <b>démocratiser l'accès à des cours particuliers de qualité</b> et personnalisés, le tout, simplement pour
            les élèves et les étudiants. Nous aidons les élèves et familles à sélectionner l'étudiant certifié pour des cours particuliers le plus adapté à leurs
            besoins spécifiques.
            <br/><br/>
            <b>Les étudiants choisissent les élèves</b> qu’ils souhaitent accompagner sans engagement dans le temps. Tu pourras trouver des élèves du primaire jusqu’au niveau prépa pour les concours les plus prestigieux et sur toutes les matières scolaires et académiques.
            <br/><br/>
            Tu as envie de <b>transmettre tes connaissances</b>, tes astuces, ta méthode ou encore <b>encourager ou coacher un élève</b>, être très bien rémunéré tout en te sentant utile et libre, alors rejoins-nous...
            <br/><br/>
            <b>... ils t’attendent !</b>
          </Box>
        </BlockItem2Styled>
      </BlockStyled>
    </Box>
  )
}

StudentCommunitySection.defaultProps = {
  title: 'Rejoins une communauté de profs étudiants motivé.e et motivante !',
};

export default StudentCommunitySection;